export default {
  methods: {
    invoiceStatusStyleClass(statusString, typeLetter, emphasize) {

      switch (statusString) {

        case 'paid':
          return 'success-light'

        case 'confirmed':
          if (typeLetter === 'E') {
            return 'success-light'
          } else if (emphasize) {
            return 'danger'
          } else {
            return 'info-light'
          }

        case 'debt':
          return'danger'

        case 'draft':
          return 'warning-light'

        default:
          return 'light'
      }
    }
  }
}
